import { get, post, put, destroy } from '../lib/api';

export function save(growerId, boundary) {
  return boundary.id
    ? put(`/growers/${growerId}/irrigation/${boundary.id}`, boundary)
    : post(`/growers/${growerId}/irrigation`, boundary);
}

export function destroyBoundary(growerId, boundary) {
  return destroy(`/growers/${growerId}/irrigation/${boundary.id}`);
}

export function getBoundaries(growerId) {
  return get(`/growers/${growerId}/irrigation`);
}
